import React, { useEffect, useState } from "react"
import Moment from "react-moment";
import { getFieldData, getFormatedNumber } from "../../Services/appService";
import { useNavigate } from "react-router-dom";
import PurchaseOrders from "../../Components/ApplicantProcessing/PurchaseOrders";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser, getLoggedUserDetails, loadUserDetails } from "../store/auth";
import { getPartnerAllCandidate, loadPartnerAllCandidate } from "../store/partner";
import { setCurrentPageTitle, setCurrentRoute } from "../store/layoutUI";
import { getComponentUserStatus, getToolsCount, UpdateComponentsUserStatus } from "../store/tools";

const PARTNER_CANDIDATE_STYLES = {
    shell: {
        background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        borderRadius: "20px",
        boxShadow: "0 16px 40px rgba(15, 23, 42, 0.06)",
        overflow: "hidden"
    },
    hero: {
        padding: "20px 22px 16px 22px",
        background: "linear-gradient(135deg, #eff6ff 0%, #f8fafc 55%, #ffffff 100%)",
        borderBottom: "1px solid rgba(203, 213, 225, 0.75)"
    },
    heroRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        flexWrap: "wrap"
    },
    heroCopy: {
        flex: "1 1 420px",
        minWidth: "280px"
    },
    titleRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: "12px"
    },
    titleIcon: {
        width: "34px",
        height: "34px",
        borderRadius: "10px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#eff6ff",
        color: "#1d4ed8",
        fontSize: "15px",
        border: "1px solid rgba(191, 219, 254, 1)",
        flexShrink: 0
    },
    titleText: {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        minWidth: 0
    },
    eyebrow: {
        display: "inline-block",
        marginBottom: "8px",
        color: "#2563eb",
        fontSize: "11px",
        fontWeight: 700,
        letterSpacing: "0.12em",
        textTransform: "uppercase"
    },
    title: {
        margin: 0,
        color: "#0f172a",
        fontSize: "18px",
        fontWeight: 800,
        lineHeight: 1.25
    },
    subtitle: {
        margin: 0,
        color: "#64748b",
        fontSize: "13px",
        lineHeight: 1.5,
        maxWidth: "760px"
    },
    heroBadgeRow: {
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    refreshButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        color: "#334155",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700
    },
    heroBadge: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        padding: "10px 14px",
        borderRadius: "999px",
        border: "1px solid rgba(191, 219, 254, 1)",
        backgroundColor: "#ffffff",
        color: "#1d4ed8",
        fontSize: "12px",
        fontWeight: 700,
        boxShadow: "0 8px 22px rgba(37, 99, 235, 0.08)"
    },
    statsGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
        gap: "14px",
        padding: "18px 22px 0 22px"
    },
    statCard: {
        borderRadius: "16px",
        border: "1px solid rgba(226, 232, 240, 1)",
        backgroundColor: "#ffffff",
        padding: "16px",
        boxShadow: "0 8px 20px rgba(15, 23, 42, 0.04)"
    },
    statLabel: {
        margin: 0,
        color: "#64748b",
        fontSize: "11px",
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase"
    },
    statValue: {
        margin: "10px 0 6px 0",
        color: "#0f172a",
        fontSize: "28px",
        fontWeight: 700,
        lineHeight: 1
    },
    statMeta: {
        margin: 0,
        color: "#475569",
        fontSize: "13px",
        lineHeight: 1.5
    },
    tableWrap: {
        padding: "18px 22px 22px 22px"
    },
    tableShell: {
        border: "1px solid rgba(226, 232, 240, 1)",
        borderRadius: "18px",
        overflow: "hidden",
        backgroundColor: "#ffffff",
        boxShadow: "0 12px 28px rgba(15, 23, 42, 0.05)"
    },
    table: {
        marginBottom: 0,
        tableLayout: "fixed"
    },
    tableHeadCell: {
        borderTop: "none",
        fontSize: "12px",
        fontWeight: 800,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#64748b",
        background: "#f8fafc",
        padding: "14px 16px"
    },
    tableCell: {
        verticalAlign: "middle",
        padding: "18px 16px",
        borderTop: "1px solid rgba(241, 245, 249, 1)",
        background: "#ffffff"
    },
    sectionTitle: {
        margin: "0 0 6px 0",
        color: "#0f172a",
        fontSize: "18px",
        fontWeight: 700
    },
    sectionSubtitle: {
        margin: "0 0 18px 0",
        color: "#64748b",
        fontSize: "13px"
    },
    candidateName: {
        margin: 0,
        color: "#0f172a",
        fontSize: "15px",
        fontWeight: 700,
        textTransform: "uppercase"
    },
    infoText: {
        display: "block",
        color: "#475569",
        fontSize: "13px",
        lineHeight: 1.5
    },
    idPill: {
        display: "inline-flex",
        alignItems: "center",
        padding: "5px 10px",
        borderRadius: "999px",
        backgroundColor: "#e0f2fe",
        color: "#075985",
        fontSize: "12px",
        fontWeight: 700,
        marginBottom: "8px"
    },
    secondaryPill: {
        display: "inline-flex",
        alignItems: "center",
        padding: "4px 10px",
        borderRadius: "999px",
        backgroundColor: "#f1f5f9",
        color: "#475569",
        fontSize: "12px",
        fontWeight: 600
    },
    statusBadge: {
        display: "inline-flex",
        alignItems: "center",
        padding: "6px 12px",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 700
    },
    actionButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        minHeight: "36px",
        borderRadius: "999px",
        border: "1px solid rgba(224, 231, 255, 1)",
        background: "#eef2ff",
        color: "#4338ca",
        padding: "7px 14px",
        fontSize: "12px",
        fontWeight: 700,
        textDecoration: "none",
        whiteSpace: "normal",
        lineHeight: 1.25,
        textAlign: "center"
    },
    emptyState: {
        padding: "42px 24px",
        textAlign: "center",
        backgroundColor: "#ffffff"
    },
    emptyIcon: {
        width: "64px",
        height: "64px",
        margin: "0 auto 14px auto",
        borderRadius: "18px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%)",
        color: "#2563eb",
        fontSize: "26px"
    },
    emptyTitle: {
        margin: 0,
        color: "#0f172a",
        fontSize: "18px",
        fontWeight: 700
    },
    emptyText: {
        margin: "10px auto 0 auto",
        maxWidth: "520px",
        color: "#64748b",
        fontSize: "14px",
        lineHeight: 1.6
    }
};

export default function PartnerCandidates() {

    const route = [{ name: "Contract Management", url: "" }];

    const [candidateList, setCandidateList] = useState([]);
    const [candidateObj, setCandidateObj] = useState(null);
    const [poShowHide, setPoShowHide] = useState(false);
    const [userDetails, setUserDetails] = useState(false);
    const [appStatus, setAppStatus] = useState(false);
    const [appApproved, setAppApproved] = useState(false);

    const userDetailsSelector = useSelector(getLoggedUserDetails);
    const partnerAllCandidateSelector = useSelector(getPartnerAllCandidate);
    const componentUserStatusSelector = useSelector(getComponentUserStatus);
    const toolsCountSelector = useSelector(getToolsCount);

    const navigate = useNavigate();
    const currentUser = getCurrentUser();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentPageTitle("List of Candidates"));
        dispatch(setCurrentRoute(route))
    }, [])

    useEffect(() => {
        let usrId = currentUser.id;
        if (currentUser.linkUser)
            usrId = currentUser.linkUser;
        if (!userDetailsSelector)
            dispatch(loadUserDetails(usrId));

    }, []);

    useEffect(() => {
        if (userDetailsSelector && userDetailsSelector?.partnerid) {
            setUserDetails(userDetailsSelector);
            setAppStatus(userDetailsSelector?.appSubmit);
            setAppApproved(userDetailsSelector?.approved > 0);
            if (userDetailsSelector?.approved > 0)
                dispatch(loadPartnerAllCandidate(userDetailsSelector.partnerid, 0))
        }
    }, [userDetailsSelector]);

    useEffect(() => {
        if (partnerAllCandidateSelector.length > 0) {
            setCandidateList(partnerAllCandidateSelector);
            let candItems = "";
            partnerAllCandidateSelector.map((x, key) => {
                if (key > 0) candItems += ",";
                candItems += x.performerid;
            });

            const appObj = toolsCountSelector?.filter(x => x.key === 0);
            let appCiid = 0;
            if (appObj.length > 0)
                appCiid = appObj[0].value;

            handleUpdateComponent(candItems, appCiid);
        } else {
            setCandidateList([]);
        }
    }, [partnerAllCandidateSelector]);

    const usrType = localStorage.getItem("userType");

    const handleUploadDoc = (item) => {
        navigate("/CandidateWorkingHub", { state: item });
    }

    const handlePoShowHide = (obj) => {
        setPoShowHide(!poShowHide);
        setCandidateObj(obj);
    };

    const handleUpdateComponent = (compItems, ciid) => {
        const comp = componentUserStatusSelector.filter(x => x.compId === 19);
        let updCompItems = "";
        if (comp.length > 0) {
            updCompItems = comp[0].compItems;
        }
        const compObj = {
            compName: "Partner Candidate",
            performerId: currentUser.id,
            compItems: compItems,
            ciid: ciid,
            wiid: 0,
            iiid: 0,
            compId: 19
        }
        if (compItems !== "" && compItems !== updCompItems) {
            dispatch(UpdateComponentsUserStatus(compObj));
        }
    }

    const getPendingPoCount = (obj) => {
        let poType = "recruiter";
        if (userDetails?.partnerType === "Sub-Contractors") {
            poType = "subcontractor";
        }

        return obj?.poTypes?.filter(x => x.type === poType && x.partnerSign !== true && x.sendStatus === true).length || 0;
    }

    const getTotalPoCount = (obj) => {
        let poType = "recruiter";
        if (userDetails?.partnerType === "Sub-Contractors") {
            poType = "subcontractor";
        }

        return obj?.poTypes?.filter(x => x.type === poType && x.sendStatus === true).length || 0;
    }

    const getPoCount = (obj) => {
        const pendingCount = getPendingPoCount(obj);
        const totalCount = pendingCount === 0 ? getTotalPoCount(obj) : pendingCount;
        const badgeClass = pendingCount === 0 ? "badge-success" : "badge-danger";

        return <span className={`badge badge-pill ${badgeClass} ml-2`}>
            {totalCount}
        </span>
    }


    const handleRefreshPartnerCandidates = () => {
        if (userDetailsSelector && userDetailsSelector?.partnerid) {
            setUserDetails(userDetailsSelector);
            dispatch(loadPartnerAllCandidate(userDetailsSelector.partnerid, 0))
        }
    }

    const completedCount = candidateList.filter(item => item.appSubmit).length;
    const pendingCount = candidateList.length - completedCount;
    const totalPendingPoCount = candidateList.reduce((sum, item) => sum + getPendingPoCount(item), 0);
    const totalPoCount = candidateList.reduce((sum, item) => sum + getTotalPoCount(item), 0);

    const getStatusBadgeStyle = (isComplete) => ({
        ...PARTNER_CANDIDATE_STYLES.statusBadge,
        backgroundColor: isComplete ? "#dcfce7" : "#fef3c7",
        color: isComplete ? "#166534" : "#92400e"
    });

    return <React.Fragment>
        <div className="mt-2">
            <style>{`
                .partner-candidates-table tbody tr:hover td {
                    background-color: #f8fbff !important;
                }

                @media (max-width: 991.98px) {
                    .partner-candidates-table {
                        min-width: 1040px;
                    }
                }
            `}</style>
            <div className="card shadow-none border-1" style={PARTNER_CANDIDATE_STYLES.shell}>
                <div style={PARTNER_CANDIDATE_STYLES.hero}>
                    <div style={PARTNER_CANDIDATE_STYLES.heroRow}>
                        <div style={PARTNER_CANDIDATE_STYLES.heroCopy}>
                            <div style={PARTNER_CANDIDATE_STYLES.titleRow}>
                                <span style={PARTNER_CANDIDATE_STYLES.titleIcon}>
                                    <i className="fa fa-list-ul" aria-hidden="true"></i>
                                </span>
                                <div style={PARTNER_CANDIDATE_STYLES.titleText}>
                                    <h2 style={PARTNER_CANDIDATE_STYLES.title}>List of Your Candidates</h2>
                                    <p style={PARTNER_CANDIDATE_STYLES.subtitle}>
                                        Review onboarding progress, track purchase order activity, and jump directly into candidate-specific actions.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style={PARTNER_CANDIDATE_STYLES.heroBadgeRow}>
                            <button
                                type="button"
                                className="btn btn-sm"
                                style={PARTNER_CANDIDATE_STYLES.refreshButton}
                                onClick={handleRefreshPartnerCandidates}
                            >
                                <i className="fa fa-refresh" aria-hidden="true"></i>
                                Refresh
                            </button>

                        </div>
                    </div>
                </div>
                <div style={PARTNER_CANDIDATE_STYLES.statsGrid}>
                    <div style={PARTNER_CANDIDATE_STYLES.statCard}>
                        <p style={PARTNER_CANDIDATE_STYLES.statLabel}>Total Candidates</p>
                        <p style={PARTNER_CANDIDATE_STYLES.statValue}>{candidateList.length}</p>
                        <p style={PARTNER_CANDIDATE_STYLES.statMeta}>Candidates currently assigned to your partner account.</p>
                    </div>
                    <div style={PARTNER_CANDIDATE_STYLES.statCard}>
                        <p style={PARTNER_CANDIDATE_STYLES.statLabel}>Onboarding Complete</p>
                        <p style={PARTNER_CANDIDATE_STYLES.statValue}>{completedCount}</p>
                        <p style={PARTNER_CANDIDATE_STYLES.statMeta}>Fully submitted candidate onboarding records.</p>
                    </div>
                    <div style={PARTNER_CANDIDATE_STYLES.statCard}>
                        <p style={PARTNER_CANDIDATE_STYLES.statLabel}>Awaiting Attention</p>
                        <p style={PARTNER_CANDIDATE_STYLES.statValue}>{pendingCount}</p>
                        <p style={PARTNER_CANDIDATE_STYLES.statMeta}>Candidates still pending onboarding completion.</p>
                    </div>
                    <div style={PARTNER_CANDIDATE_STYLES.statCard}>
                        <p style={PARTNER_CANDIDATE_STYLES.statLabel}>Purchase Orders</p>
                        <p style={PARTNER_CANDIDATE_STYLES.statValue}>{totalPendingPoCount}</p>
                        <p style={PARTNER_CANDIDATE_STYLES.statMeta}>
                            Pending eSign items across {totalPoCount} shared purchase orders.
                        </p>
                    </div>
                </div>
                <div style={PARTNER_CANDIDATE_STYLES.tableWrap}>

                    <div className="table-responsive" style={PARTNER_CANDIDATE_STYLES.tableShell}>
                        <table className="table align-items-center table-hover mb-0 partner-candidates-table" style={PARTNER_CANDIDATE_STYLES.table}>
                            <thead>
                                <tr>
                                    <th style={PARTNER_CANDIDATE_STYLES.tableHeadCell}>Candidate #<br />IPCS ID</th>
                                    <th style={PARTNER_CANDIDATE_STYLES.tableHeadCell}>Details</th>
                                    <th style={PARTNER_CANDIDATE_STYLES.tableHeadCell}>Agency</th>
                                    <th style={PARTNER_CANDIDATE_STYLES.tableHeadCell}>Duration<br />(Start-End)</th>
                                    <th style={PARTNER_CANDIDATE_STYLES.tableHeadCell}>Onboarding<br />Status</th>
                                    <th style={PARTNER_CANDIDATE_STYLES.tableHeadCell}>Purchase Orders</th>
                                    {usrType !== "recruiter" && <th style={PARTNER_CANDIDATE_STYLES.tableHeadCell}>Action</th>}

                                </tr>
                            </thead>
                            <tbody>
                                {candidateList.length > 0 && candidateList.map((item) => (
                                    <tr key={item.performerid}>
                                        <td style={PARTNER_CANDIDATE_STYLES.tableCell}>
                                            <span style={PARTNER_CANDIDATE_STYLES.idPill}>{item.performerid}</span>
                                            <br />
                                            <span style={PARTNER_CANDIDATE_STYLES.secondaryPill}>
                                                IPCS ID: {item.maxloans || "N/A"}
                                            </span>
                                        </td>
                                        <td style={PARTNER_CANDIDATE_STYLES.tableCell}>
                                            <p style={PARTNER_CANDIDATE_STYLES.candidateName}>
                                                {item.performername} {item.lastName}
                                            </p>
                                            <span style={PARTNER_CANDIDATE_STYLES.infoText}>{item.performeremail || "Email not available"}</span>
                                            <span style={PARTNER_CANDIDATE_STYLES.infoText}>{item.contactNo ? getFormatedNumber(item.contactNo) : "Phone not available"}</span>
                                            <span style={PARTNER_CANDIDATE_STYLES.infoText}>
                                                {getFieldData(
                                                    item.performerData,
                                                    "projectengagement",
                                                    "PositionTitle"
                                                ) || "Position title not available"}
                                            </span>
                                        </td>
                                        <td style={PARTNER_CANDIDATE_STYLES.tableCell}>
                                            <span style={PARTNER_CANDIDATE_STYLES.infoText}>
                                                {getFieldData(
                                                    item.performerData,
                                                    "projectengagement",
                                                    "AgencyName"
                                                ) || "Agency not available"}
                                            </span>
                                        </td>
                                        <td style={PARTNER_CANDIDATE_STYLES.tableCell}>
                                            {item.duration && (
                                                <React.Fragment>
                                                    <span style={PARTNER_CANDIDATE_STYLES.infoText}>{item.duration.duration} Months</span>
                                                    <span style={PARTNER_CANDIDATE_STYLES.infoText}>
                                                        Start:{" "}
                                                        <Moment format="MMM Do YYYY">
                                                            {item.duration.startDate}
                                                        </Moment>
                                                    </span>
                                                    <span style={PARTNER_CANDIDATE_STYLES.infoText}>
                                                        End:{" "}
                                                        <Moment format="MMM Do YYYY">
                                                            {item.duration.endDate}
                                                        </Moment>
                                                    </span>
                                                </React.Fragment>
                                            )}
                                            {!item.duration && (
                                                <span style={PARTNER_CANDIDATE_STYLES.infoText}>Duration not available</span>
                                            )}
                                        </td>
                                        <td style={PARTNER_CANDIDATE_STYLES.tableCell}>
                                            <span style={getStatusBadgeStyle(item.appSubmit)}>
                                                {item.appSubmit ? "Complete" : "Pending"}
                                            </span>
                                        </td>
                                        <td style={PARTNER_CANDIDATE_STYLES.tableCell}>
                                            <button
                                                className="btn btn-sm border-0"
                                                onClick={() => handlePoShowHide(item)}
                                                style={PARTNER_CANDIDATE_STYLES.actionButton}
                                            >
                                                View and eSign
                                                {getPoCount(item)}
                                            </button>
                                        </td>
                                        {usrType !== "recruiter" &&
                                            <td style={PARTNER_CANDIDATE_STYLES.tableCell}>
                                                <button
                                                    onClick={() => handleUploadDoc(item)}
                                                    className="btn btn-sm btn-outline-primary"
                                                    style={PARTNER_CANDIDATE_STYLES.actionButton}
                                                >
                                                    Upload Required Documents
                                                </button>
                                            </td>}
                                    </tr>
                                ))}
                                {candidateList.length === 0 && (
                                    <tr>
                                        <td colSpan={usrType !== "recruiter" ? 7 : 6} className="p-0 border-0">
                                            <div style={PARTNER_CANDIDATE_STYLES.emptyState}>
                                                <div style={PARTNER_CANDIDATE_STYLES.emptyIcon}>
                                                    <i className="fa fa-users" aria-hidden="true"></i>
                                                </div>
                                                <h4 style={PARTNER_CANDIDATE_STYLES.emptyTitle}>No candidates to show yet</h4>
                                                <p style={PARTNER_CANDIDATE_STYLES.emptyText}>
                                                    Candidate records will appear here once onboarding is approved and linked to your partner account.
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <PurchaseOrders
            poShowHide={poShowHide}
            handlePoShowHide={handlePoShowHide}
            candidateObj={candidateObj}
            handleRefreshPartnerCandidates={handleRefreshPartnerCandidates}
        ></PurchaseOrders>
    </React.Fragment>
}
